import React, { useState } from 'react';
import { FactureOpenSearch } from '@europrocurement/l2d-domain';
import { useDownload } from '@europrocurement/l2d-modules/hooks';
import { useBilling } from '@europrocurement/l2d-modules/modules/Dossiers';
import { enqueueSnackbar } from 'notistack';
import { CircularProgress, MenuItem, Typography } from '@mui/material';
import { FaOptionIcon } from '@europrocurement/l2d-icons';

export type menuDownloadInvoiceType = {
    facture: FactureOpenSearch;
};
const MenuDownloadInvoice: React.FunctionComponent<menuDownloadInvoiceType> = function ({
    facture,
}) {
    const { download } = useDownload();
    const { downloadInvoice } = useBilling({});
    const [downloadProcessing, setDownloadProcessing] = useState<boolean>(false);

    const getInvoiceLabel = (): string => {
        if (facture.type && facture.type === 'AVOIR') {
            return `Avoir ${facture.factureNumero}.pdf`;
        }
        return `Facture ${facture.factureNumero}.pdf`;
    };

    const handleDownload = (fileName: string, id: number) =>
        new Promise((resolve, reject) => {
            downloadInvoice(id)
                .then((fileContent: Blob) => {
                    download(fileName, fileContent);

                    resolve(undefined);
                })
                .catch(reject);
        });

    const handleDownloadClick = () => {
        if (!downloadProcessing && facture?.id) {
            handleDownload(getInvoiceLabel(), facture.id)
                .then(() => {})
                .catch(() =>
                    enqueueSnackbar('Une erreur est survenue lors du téléchargement du document', {
                        variant: 'error',
                    }),
                )
                .finally(() => setDownloadProcessing(false));
            setDownloadProcessing(true);
        }
    };

    return (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>
            {downloadProcessing ? (
                <MenuItem sx={{ gap: '4px' }}>
                    <CircularProgress size="16px" />
                </MenuItem>
            ) : (
                <MenuItem
                    sx={{ gap: '4 px' }}
                    onClick={handleDownloadClick}
                >
                    <FaOptionIcon
                        icon={['fasl', 'arrow-down-to-line']}
                        color="text.gris70"
                    />
                    <Typography sx={{ color: 'text.primary' }}>Télécharger</Typography>
                </MenuItem>
            )}
        </>
    );
};

export default MenuDownloadInvoice;
